:host([visually-hidden]) {
    ::slotted(a) {
        clip: rect(1px, 1px, 1px, 1px);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }
    ::slotted(a:focus-visible) {
        outline: 2px dashed #356799;
        clip: auto;
        display: block;
        width: 20%;
        overflow: visible;
        margin: 0 auto;
        height: auto;
        top: 5px;
        left: 30%;
        right: 30%;
        text-align: center;
        z-index: 5000;
        color: #356799;
        padding: 10px;
      }
  
}
